"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.column.slot ? _c("el-table-column", _vm._b({
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._t("default", function () {
          return [_vm._v(" " + _vm._s(scope.column && scope.row[scope.column.property]) + " ")];
        }, null, scope)];
      }
    }, {
      key: "header",
      fn: function (scope) {
        return [_vm._t("header", function () {
          return [_vm._v(" " + _vm._s(scope.column && scope.column.label) + " ")];
        }, null, scope)];
      }
    }], null, true)
  }, "el-table-column", _vm.elAttrs, false)) : _c("el-table-column", _vm._b({}, "el-table-column", _vm.elAttrs, false));
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;